import { memo } from 'react';

import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import PropTypes from 'prop-types';

import AppTypography from '@components/common/AppTypography';

const AppLoader = memo(function AppLoader({
  size = 40,
  label = 'Loading…',
  fullHeight = false,
  sx,
  ...rest
}) {
  return (
    <Box
      role="status"
      aria-live="polite"
      aria-busy="true"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 1.5,
        minHeight: fullHeight ? '50vh' : 120,
        ...sx,
      }}
      {...rest}
    >
      <CircularProgress size={size} />
      {label ? (
        <AppTypography variant="body2" color="text.secondary">
          {label}
        </AppTypography>
      ) : null}
    </Box>
  );
});

AppLoader.propTypes = {
  size: PropTypes.number,
  label: PropTypes.string,
  fullHeight: PropTypes.bool,
  sx: PropTypes.object,
};

export default AppLoader;
